import classNames from 'classnames';
import { useRef, useState } from 'react';
import { Checkbox, Image, MessagePlugin } from 'tdesign-react';

import { EyesIcon } from '@/components/icon';
import SpineWebPlayer from '@/material/form-upload/core/player/spine';
import { SpinePlayerRef } from '@/material/form-upload/spine';
import { UserResourceDetail } from '@/services/library';

import ReviewDialog from './dialog';
import styles from './index.module.less';

const LibrarySpineViewer: React.FC<{
  value?: UserResourceDetail;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  children?: React.ReactNode;
}> = (props) => {
  const { checked = false, onCheckedChange, value } = props;
  const [hover, setHover] = useState(false);
  const [visible, setVisible] = useState(false);
  const playerRef = useRef<SpinePlayerRef>(null);

  const handleChange = (value: boolean) => {
    onCheckedChange?.(value);
  };

  const onClose = () => {
    setVisible(false);
  };

  const triggerPlay = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    try {
      e.stopPropagation();
      setVisible(true);
    } catch (error) {
      MessagePlugin.error('该视频不支持预览');
    }
  };

  const mask = (
    <div
      onClick={() => handleChange(!checked)}
      style={{
        color: '#fff',
        height: '100%',
        position: 'absolute',
        width: '100%',
        borderRadius: 6,
      }}
    >
      {
        (hover) || (checked && hover)
          ? <span className={styles.browseIcon} onClick={triggerPlay}>
            <EyesIcon name={'browse'} />
          </span> : null
      }
      {
        hover || checked
          ? <span className={styles.checkboxIcon}>
            <Checkbox checked={checked}></Checkbox>
          </span> : null
      }
    </div>
  );

  return (
    <div>
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={classNames(styles.content, styles.videoContent, { [styles.active]: checked })}>
        <div>
          <div>
            <Image
              src={value?.spine?.images?.[0]}
              fit={'contain'}
              style={{ width: 136, height: 136 }}
            />
          </div>
          <ReviewDialog visible={visible} onClose={onClose}>
            <SpineWebPlayer
              value={value?.spine}
              playerRef={playerRef}
              showControls={true}
              config={{
                width: '800px',
                height: '500px',
              }}
            />
          </ReviewDialog>
          {props?.children}
        </div>
        {hover || checked ? <div className={styles.mask}>{mask}</div> : null}
      </div>
    </div>
  );
};

export default LibrarySpineViewer;
